// @flow
import alt from '../alt';

import SettingsActions from '../actions/SettingsActions';
import type {IntegerType} from "../model";
import type {SettingsItems} from "../Grobot/Settings";
import ProductConfig from "../ProductConfig";
import AppConfig from "../config";

/**
 * Wrapper klass vanale settings objektile
 */
class SettingsStore {
    state: SettingsItems;

    constructor() {
        this.state = {};
        this.bindActions(SettingsActions);
        this.exportPublicMethods({
            getLineCount: this.getLineCount,
            getCenterAddPoints: this.getCenterAddPoints,
            getHudPoints: this.getHudPoints,
            getAdasAreasCount: this.getAdasAreasCount,
            isNcpRotated: this.isNcpRotated,
            isSimpleUi: this.isSimpleUi,
            getGlassFileType: this.getGlassFileType,
            getYshiftOffset: this.getYshiftOffset,
            isRotatedMeasurementAllowed: this.isRotatedMeasurementAllowed,
            getProductConfig: this.getProductConfig
        });
    }

    onSettingsUpdated(settings: SettingsItems): void {
        this.setState(settings);
    }

    getLineCount(): IntegerType {
        return this.state.conf_measurement_line_count ?? 3;
    }

    getCenterAddPoints(): IntegerType {
        return this.state.conf_center_add_points ?? 0;
    }

    getHudPoints(): IntegerType {
        return this.state.conf_hud_points ?? 0;
    }

    getAdasAreasCount(): IntegerType {
        return this.state.conf_adas_area_count ?? 6;
    }

    getAnglePoints(): IntegerType {
        return this.state.conf_angle_points ?? 1;
    }


    isNcpRotated(): boolean {
        return this.state.ncpRotated ?? false;
    }

    isSimpleUi(): boolean {
        return this.state.conf_simple_ui ?? false;
    }

    getGlassFileType(): string {
        return this.state.conf_glass_file_type ?? "dat,ncp";
    }

    getYshiftOffset(): IntegerType {
        return this.state.conf_yshift_offset ?? 763;
    }

    isRotatedMeasurementAllowed(): boolean {
        return this.state.conf_rotated_measurement_allowed;
    }

    getProductConfig(): ProductConfig {
        return new ProductConfig({
            lineCount: this.getLineCount(),
            addPoints: this.getCenterAddPoints(),
            hudPoints: this.getHudPoints(),
            adasAreasCount: this.getAdasAreasCount(),
            angleCount: AppConfig.ANGLE_COUNT
        });
    }
}

export default alt.createStore(SettingsStore, 'SettingsStore');
